/** FA catalog — ارتباط با خانواده (ZOY-665): تب پرونده، میز کار، صندوق درخواست‌ها. */
export const familyFa: Record<string, string> = {
  'nav.family': 'خانواده',
  'rec.tab.family': 'خانواده',

  'family.st.pending': 'در انتظار پاسخ',
  'family.st.accepted': 'متصل',
  'family.st.declined': 'رد شده',
  'family.st.expired': 'منقضی شده',
  'family.st.cancelled': 'لغو شده',
  'family.st.withdrawn': 'توسط خانواده پس‌گرفته شد',
  'family.st.superseded': 'جایگزین شده',
  'family.st.ended': 'پایان‌یافته',
  'family.local.creating': 'در حال ارسال…',
  'family.local.failed': 'ارسال نشد',
  'family.kind.invitation': 'دعوت',
  'family.kind.request': 'درخواست خانواده',
  'family.kind.connection': 'ارتباط',
  'family.endedBy.clinic_ended': 'از سوی مرکز پایان یافت',
  'family.endedBy.family_ended': 'از سوی خانواده پایان یافت',

  'family.tab.title': 'ارتباط با خانواده',
  'family.tab.sub':
    'حساب خانوادگی ای که این پرونده به آن وصل است، و هر دعوتی که به آن راه می‌رسد. خانواده برنامه درمان را از طریق همین ارتباط می‌بیند.',
  'family.tab.guest': 'پرونده مهمان نمی‌تواند به یک خانواده وصل شود. اول ثبت‌نام را کامل کنید.',
  'family.tab.merged': 'این پرونده در پرونده دیگری ادغام شد؛ ارتباطش همان‌جا زندگی می‌کند.',
  'family.tab.current': 'خانوادهٔ متصل',
  'family.tab.currentSince': 'وصل شده از {date}',
  'family.tab.accountName': 'حساب خانوادگی',
  'family.tab.accountUnknown': 'نام هنوز به اشتراک گذاشته نشده',
  'family.tab.nameNote':
    'این نام همان نام نمایشی حساب خانواده است و فقط برای آگاهی شماست. تفاوتش با نام همراهِ ثبت‌شده به‌خودی‌خود چیزی را عوض نمی‌کند.',
  'family.tab.noConnection': 'خانواده‌ای وصل نیست',
  'family.tab.noConnectionBody':
    'یکی از شماره‌های روی این پرونده را دعوت کنید. دعوت وقتی آن شماره وارد شود در برنامه خانواده ظاهر می‌شود؛ چیزی از طریق پیامک فرستاده نمی‌شود.',
  'family.tab.open': 'در انتظار پاسخ',
  'family.tab.history': 'تاریخچه',
  'family.tab.historyEmpty': 'هنوز چیزی نیست.',
  'family.tab.inconsistent':
    'دو ارتباط هنوز فعال خوانده می‌شوند — سامانه مرکز در حال همگام شدن با یک تغییر اخیر است. کمی بعد بازخوانی کنید.',
  'family.tab.synced': 'آخرین همگام سازی {when}',
  'family.tab.neverSynced': 'هنوز همگام نشده',
  'family.tab.refresh': 'به‌روزرسانی',
  'family.tab.refreshRequested': 'بازخوانی درخواست شد — فهرست در همگام سازی بعدی به‌روز می‌شود.',
  'family.tab.invite': 'دعوت از عضو خانواده',
  'family.tab.needsManage': 'دعوت و پایان‌دادن به ارتباط‌ها به مجوز مدیریت خانواده نیاز دارد.',

  'family.invite.title': 'دعوت از عضو خانواده',
  'family.invite.body':
    'یکی از شماره‌هایی که از قبل روی این پرونده است را انتخاب کنید. شخصی که آن شماره را دارد بعد از ورود با آن، دعوت را در برنامه خانواده می‌بیند.',
  'family.invite.mobile': 'شمارهٔ دعوت',
  'family.invite.contactLabel': 'شماره تماس پرونده',
  'family.invite.note': 'یادداشت برای خانواده (اختیاری)',
  'family.invite.noteHelp':
    'فقط داخل برنامه خانواده نشان داده می‌شود، هیچ‌وقت در یک پیام. جزئیات مراجع را کم نگه دارید.',
  'family.invite.send': 'ارسال دعوت',
  'family.invite.noNumbers': 'این پرونده شماره‌ای برای دعوت ندارد.',
  'family.invite.sent': 'دعوت فرستاده شد',
  'family.invite.sentBody': '۷ روز باز می‌ماند. می‌توانید دوباره بفرستید یا در پایین لغو کنید.',

  'family.row.to': 'به {mobile}',
  'family.row.from': 'از {name} · {mobile}',
  'family.row.fromUnknown': 'از یک حساب خانوادگی بی‌نام',
  'family.row.message': 'پیام آن‌ها: {text}',
  'family.row.note': 'یادداشت: {text}',
  'family.row.sent': 'فرستاده شده {n, plural, one {یک‌بار} other {# بار}} · آخرین {when}',
  'family.row.expires': 'منقضی می‌شود {when}',
  'family.row.decided': '{when}',
  'family.row.declineReason': 'دلیل: {reason}',
  'family.row.declineNote': '«{note}»',
  'family.row.ended': 'تمام‌شده {when} — {by}',
  'family.row.accepted': 'پذیرفته‌شده {when}',
  'family.row.by': 'توسط {name}',
  'family.row.failed':
    'سامانه مرکز نتوانست این را کامل کند. برای تلاش دوباره همان شماره را دعوت کنید.',
  'family.act.resend': 'ارسال دوباره',
  'family.act.cancel': 'لغو دعوت',
  'family.act.end': 'پایان ارتباط',
  'family.act.accept': 'پذیرش…',
  'family.act.decline': 'رد…',
  'family.act.resendWait': 'ارسال دوباره در {wait} ممکن است',
  'family.act.resent': 'دعوت دوباره فرستاده شد',
  'family.act.cancelled': 'دعوت لغو شد',

  'family.end.title': 'این ارتباط با خانواده پایان یابد؟',
  'family.end.body':
    'خانواده دیگر چیز تازه‌ای از برنامه درمان این پرونده دریافت نمی‌کند. آنچه از قبل به اشتراک گذاشته شد به‌عنوان تاریخچه برایشان قابل مشاهده می‌ماند — چیزی پس‌گرفته نمی‌شود.',
  'family.end.effectTitle': 'چه چیزی عوض می‌شود',
  'family.end.effect':
    'مرکز تاریخچه خودش را نگه می‌دارد. یک دعوت جدید می‌تواند بعدا خانواده را دوباره وصل کند.',
  'family.end.confirm': 'پایان ارتباط',
  'family.end.done': 'ارتباط پایان یافت',

  'family.reason.wrong_number': 'شماره اشتباه است',
  'family.reason.not_now': 'فعلاً نه',
  'family.reason.unknown_clinic': 'این مرکز را نمی‌شناسد',
  'family.reason.other': 'دلیل دیگر',
  'family.decline.title': 'این درخواست رد شود',
  'family.decline.body':
    'خانواده دلیلی که انتخاب می‌کنید را می‌بیند، و یادداشتتان را اگر اضافه کنید.',
  'family.decline.reason': 'دلیل',
  'family.decline.note': 'یادداشت برای خانواده (اختیاری)',
  'family.decline.confirm': 'رد درخواست',
  'family.decline.done': 'درخواست رد شد',

  'family.accept.title': 'پذیرش درخواست برای یک مراجع',
  'family.accept.body':
    'درخواست هیچ مراجعی را نام نمی‌برد. مراجع ثبت‌شده‌ای را که این خانواده درباره‌اش می‌پرسد انتخاب کنید — ارتباط فقط برای همان پرونده ساخته می‌شود.',
  'family.accept.requester': 'درخواست شده توسط {name} · {mobile}',
  'family.accept.byMobile': 'پرونده‌هایی که این شماره را دارند',
  'family.accept.byMobileNone': 'هیچ پرونده‌ای این شماره را ندارد.',
  'family.accept.search': 'جست‌وجوی مراجع',
  'family.accept.searchHelp': 'نام یا شماره پرونده — فقط مراجعان ثبت‌شده.',
  'family.accept.searchNone': 'مراجع ثبت‌نام‌شده‌ای پیدا نشد.',
  'family.accept.pick': 'انتخاب',
  'family.accept.picked': 'انتخاب شد',
  'family.accept.guestSkipped': 'مهمان — قابل اتصال نیست',
  'family.accept.confirm': 'پذیرش برای این مراجع',
  'family.accept.needsChoice': 'اول یک مراجع انتخاب کنید.',
  'family.accept.done': 'درخواست پذیرفته شد — خانواده متصل است.',
  'family.accept.file': 'پرونده {n}',

  'family.ws.title': 'ارتباط با خانواده',
  'family.ws.sub':
    'هر دعوت، درخواست خانواده و ارتباط مرکز. آنچه این‌جا می‌بینید نسخه سامانه مرکز است؛ سامانه خانواده تصمیم می‌گیرد.',
  'family.ws.tabLinks': 'همه ارتباط‌ها',
  'family.ws.tabRequests': 'درخواست‌ها',
  'family.ws.colPatient': 'مراجع',
  'family.ws.colKind': 'نوع',
  'family.ws.colStatus': 'وضعیت',
  'family.ws.colWith': 'خانواده',
  'family.ws.colWhen': 'به‌روزرسانی',
  'family.ws.colBy': 'توسط',
  'family.ws.fKind': 'نوع',
  'family.ws.fStatus': 'وضعیت',
  'family.ws.fAll': 'همه',
  'family.ws.fMine': 'فقط من',
  'family.ws.fFrom': 'از',
  'family.ws.fTo': 'تا',
  'family.ws.fPatient': 'یک مراجع',
  'family.ws.clearPatient': 'نمایش همه مراجعان',
  'family.ws.patientHidden': 'نام مراجعان به مجوز مراجعان نیاز دارد.',
  'family.ws.emptyTitle': 'هنوز ارتباط خانوادگی ای نیست',
  'family.ws.emptyBody':
    'دعوت‌ها از تب خانواده یک مراجع شروع می‌شوند. درخواست‌های خانواده به مرکز زیر «درخواست‌ها» ظاهر می‌شوند.',
  'family.ws.noResultsTitle': 'چیزی با این فیلترها نیست',
  'family.ws.noResultsBody': 'فیلتری را بازتر کنید یا پاکشان کنید.',
  'family.ws.openPatient': 'باز کردن',
  'family.ws.requestsEmptyTitle': 'درخواست در انتظاری نیست',
  'family.ws.requestsEmptyBody':
    'وقتی خانواده‌ای درخواست وصل شدن به این مرکز را بدهد، درخواست این‌جا ظاهر می‌شود.',
  'family.ws.requestsSub':
    'خانواده‌هایی که درخواست وصل شدن به این مرکز را داده‌اند. هر کدام نام و شماره تایید شده‌ای را نشان می‌دهد که خانواده انتخاب کرده به اشتراک بگذارد. پذیرفتن همیشه یعنی خودتان یک مراجع انتخاب می‌کنید.',
  'family.ws.pending': '{n, plural, one {# درخواست در انتظار} other {# درخواست در انتظار}}',

  'family.err.generic': 'سامانه مرکز این اقدام را نپذیرفت.',
  'family.err.alreadyConnected':
    'این مراجع از قبل خانواده وصل شده دارد. قبل از دعوت شماره دیگر، آن را تمام کنید.',
  'family.err.notRegistered': 'فقط یک مراجع ثبت‌شده می‌تواند وصل شود.',
  'family.err.mobileNotOnRecord':
    'آن شماره روی این پرونده نیست. اول آن را به‌عنوان همراه ثبت کنید، بعد دعوت کنید.',
  'family.err.mobileNotCanonical':
    'این شماره در شکل بین‌المللی ذخیره نشده. اول آن را روی پرونده اصلاح کنید.',
  'family.err.quota': 'سامانه خانواده پیش از ارسال دوباره یک مدت انتظار می‌خواهد.',
  'family.err.invalidState': 'این مورد جلوتر رفته — برای دیدن وضعیت فعلی بازخوانی کنید.',
  'family.err.notFound': 'این مورد دیگر وجود ندارد.',
  'family.err.authRefused': 'سامانه خانواده این اقدام را از شما نپذیرفت.',
  'family.err.clinicInactive':
    'این مرکز در حال حاضر غیرفعال است؛ ارتباط‌های خانوادگی منجمد شده‌اند.',
  'family.err.unavailable':
    'همین حالا به سامانه خانواده دسترسی نیست. چیزی عوض نشد — بعدا دوباره تلاش کنید.',
  'family.err.wait': 'تا {wait} دیگر دوباره تلاش کنید.',
};
